import { Card, Heading, Text } from '@chakra-ui/react';
import { StaticImageData } from 'next/image';
import { FC } from 'react';
import { Image } from '@/shared/ui';

const UseCaseCard: FC<{ title: string; imageSrc: string | StaticImageData; text: string }> = ({
  title,
  imageSrc,
  text,
}) => {
  return (
    <Card
      key={title}
      flexDir='column'
      gap='md'
      h='100%'
      pb='md'
    >
      <Image
        alt='use-case-image'
        borderTopRadius='lg'
        h='400px'
        imgSizes={{
          base: 'calc(100vw - 3rem)',
          sm: 'calc((100vw - 3rem - 20px) / 1.2)',
          md: 'calc(100vw / 2 - 6rem - 20px)',
          lg: 'calc(100vw / 3 - 6rem - 40px)',
        }}
        overflow='hidden'
        src={imageSrc}
        w='full'
      />
      <Heading
        as='h3'
        color='primary.pure'
        fontSize='2xl'
        px='md'
        textAlign='center'
        whiteSpace='pre-wrap'
      >
        {title}
      </Heading>
      <Text
        fontSize='lg'
        fontWeight='semibold'
        mb='auto'
        px='md'
        textAlign='center'
      >
        {text}
      </Text>
    </Card>
  );
};

export default UseCaseCard;
